import {
  faFont,
  faHashtag,
  faPercent,
  faToggleOn,
  faListUl,
  faCalendarAlt,
  faBox,
  faUndo
} from '@fortawesome/free-solid-svg-icons';

export const FIELD_TYPES = ['string', 'integer', 'float', 'boolean', 'select'];

export const AVAILABLE_CONTEXTS = ['reservation', 'borrowing', 'return'];

export const FIELD_TYPE_ICONS = {
  string: faFont,
  integer: faHashtag,
  float: faPercent,
  boolean: faToggleOn,
  select: faListUl
};

export const CONTEXT_ICONS = {
  reservation: faCalendarAlt,
  borrowing: faBox,
  return: faUndo
};

export const INITIAL_FIELD_STATE = {
  key: '',
  type: 'string',
  label: '',
  help_text: '',
  placeholder_text: '',
  required: false,
  description_field: false,
  contexts: [],
  options: []
};
